import * as React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { Field, FieldRenderProps, Form as FinalForm } from 'react-final-form';

import { countries } from 'config/countries';

import Dropdown from '../../fields/SimpleDropdown/Dropdown';
import { Transition } from '../transition/Transition';

import styles from './TranslateDialog.module.styl';
const [...languages] = countries;
const identity = (value: any) => value;

/**
 * DISCLAIMER: This component has been migrated from js file
 * Therefore there are so many 'any' types.
 * Please feel free to refactor it.
 */
export class TranslateDialog extends React.Component<any, any> {
  private readonly filteredFields: any[];

  private clickedButton: any;

  public constructor(props: any) {
    super(props);
    const { config } = props;
    this.filteredFields = [
      ...config.fields.filter((field: any) => field.translatable),
    ];
    this.state = {
      language: languages[0].value,
    };
  }

  private readonly validate = async (values: any) => {
    const errors: Record<string, any> = {};

    const requiredFields = this.props.config.fields
      .flat()
      .filter((field: any) => field.isRequired && field.translatable);

    requiredFields.forEach((field: any) => {
      if (!values[field.name]) {
        errors[field.name] = 'Required Field';
      }
    });

    return errors;
  };

  public render() {
    const { isOpen, handleClose } = this.props;
    const { language } = this.state;
    return (
      <Dialog
        open={isOpen}
        onClose={handleClose}
        TransitionComponent={Transition}
        scroll="body"
        fullScreen={true}
        disableEnforceFocus={true}
      >
        <div className={styles.root}>
          <Dropdown
            options={countries}
            title="Lang"
            value={language}
            onChange={this.handleLanguageChange}
          />
          <FinalForm
            onSubmit={this.onSubmit}
            validate={this.validate}
            initialValues={this.getInitialValues()}
            render={this.renderedForm}
          />
        </div>
      </Dialog>
    );
  }

  private readonly handleLanguageChange = (value: string) => {
    this.setState({
      language: value,
    });
  };

  private readonly getInitialValues = () => {
    const { initialValues } = this.props;
    const { language } = this.state;

    if (language === 'en') {
      return initialValues.en;
    }

    if (!initialValues.translation) {
      return {};
    }

    if (!initialValues.translation[language]) {
      return {};
    }

    return {
      ...initialValues.translation[language],
    };
  };
  private readonly onSubmit = async (values: any) => {
    const { initialValues, handleClose, withTranslation } = this.props;
    const translation = {} as any;

    translation.type = withTranslation;
    translation.itemId = initialValues.id;
    translation.language = this.state.language;
    translation.content = JSON.stringify(values);

    this.props.handleTranslation({
      ...values,
      language: this.state.language,
    });
    if (this.clickedButton === 'applyAndClose') {
      handleClose();
    }
  };

  private readonly renderedForm = ({
    handleSubmit,
    invalid,
    pristine,
    form: { reset },
  }: any) => {
    const { handleClose } = this.props;
    const onSubmit = (event: React.FormEvent) => {
      handleSubmit(event, this.clickedButton).then(() => {
        reset();
      });
    };
    return (
      <form onSubmit={onSubmit}>
        {this.filteredFields.map(field => {
          const renderedField = (props: FieldRenderProps<any, any>) => (
            <field.component {...props} {...field} {...this.props} />
          );

          return (
            <Field
              key={field.name}
              name={field.name}
              render={renderedField}
              parse={identity}
            />
          );
        })}
        <div className={styles.buttons}>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            name="apply"
            disabled={pristine || invalid}
            onClick={this.handleButtonClick}
          >
            Apply
          </Button>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            name="applyAndClose"
            disabled={pristine || invalid}
            onClick={this.handleButtonClick}
          >
            Apply and close
          </Button>
          <Button
            variant="contained"
            type="button"
            color="primary"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </div>
      </form>
    );
  };

  private readonly handleButtonClick = (e: any) => {
    this.clickedButton = e.currentTarget.name;
  };
}
